import login from "./login";
import users from "./users";

export default {
  ...login,
  ...users
};
